import { render } from "./UpdateCaseModal.vue?vue&type=template&id=1581ae64&scoped=true"
import script from "./UpdateCaseModal.vue?vue&type=script&lang=js"
export * from "./UpdateCaseModal.vue?vue&type=script&lang=js"

import "./UpdateCaseModal.vue?vue&type=style&index=0&id=1581ae64&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1581ae64"]])

export default __exports__